import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MANUALLY_PROMOTED_PETITION_DATA = defineFcm('manually_promoted_petition_data')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				petition_ids: {
					type: 'array',
					shape: {
						type: 'number',
					},
				},
				percent: {
					type: 'number',
				},
				channels: {
					type: 'array',
					shape: {
						type: 'string',
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
